import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { BackendRevalidateButton } from '@/backend';
import { Button } from '@/shared/Button';
import { Digits } from '@/shared/Digits';
import { cn } from '@/shared/react';
import { useBalance } from '../../wallet/api';

export const BalanceFooter: FC<{
  coin: string;
  onPriceChange?: (newPrice: string) => void;
}> = ({ coin, onPriceChange }) => {
  const { t } = useLingui();
  const balance = useBalance(coin);

  return (
    <div
      className={cn(
        'flex items-center justify-start gap-1 p-3 size-full',
        balance.isLoading && 'shimmer',
      )}
    >
      <BackendRevalidateButton
        keys={['wealth:*']}
        size={8}
        variant="text"
        className="shrink-0"
      />
      <div className="grow">
        <Digits value={balance.data?.balance} coin={coin} />
        <span className="text-content-tertiary ms-1 inline-block">{t`Available`}</span>
      </div>
      <Button
        variant="link"
        size={8}
        disabled={!balance.data?.balance || balance.isLoading}
        onClick={() =>
          balance.data?.balance && onPriceChange?.(balance.data?.balance)
        }
      >
        {t`Use Max`}
      </Button>
    </div>
  );
};
